
import React, { useState, useEffect, useRef } from 'react';
import { UserAgent, Inviter, Registerer, SessionState } from 'sip.js';
import 'bulma/css/bulma.min.css';

// const data = { server: '192.168.88.2', name: '7002', password: '!vigos!!interface#01!' }
// setConfig(data)

function WebRTC() {
  // Configuração fixa conforme os dados informados
  const [config] = useState({
    server: '192.168.88.2',
    name: '7002',
    password: '!vigos!!interface#01!'
  });
  const [userAgent, setUserAgent] = useState(null);
  const [registerer, setRegisterer] = useState(null);
  const [registrationStatus, setRegistrationStatus] = useState('Não registrado');
  const [currentSession, setCurrentSession] = useState(null);
  const [incomingSession, setIncomingSession] = useState(null);
  const [destination, setDestination] = useState('');
  const [callHistory, setCallHistory] = useState([]);
  const [autoAnswerEnabled, setAutoAnswerEnabled] = useState(false);
  const [autoAnswerTime, setAutoAnswerTime] = useState(10); // segundos
  const autoAnswerTimer = useRef(null);

  // Inicializa o UserAgent e realiza o registro com async/await
  useEffect(() => {
    const initUserAgent = async () => {
      try {
        const uri = UserAgent.makeURI(`sip:${config.name}@${config.server}`);
        if (!uri) {
          console.error('Erro ao criar URI SIP.');
          setRegistrationStatus('Erro ao criar URI SIP');
          return;
        }

        const ua = new UserAgent({
          uri,
          transportOptions: {
            wsServers: [`wss://${config.server}:8089/ws`]
          },
          authorizationUsername: config.name,
          authorizationPassword: config.password,
          sessionDescriptionHandlerFactoryOptions: {
            constraints: { audio: true, video: false }
          }
        });

        // Define delegate para receber chamadas
        ua.delegate = {
          onInvite: async (invitation) => {
            console.log("Chamada recebida de:", invitation.remoteIdentity.uri.toString());
            setIncomingSession(invitation);
            setCallHistory(prev => [
              ...prev,
              { type: 'Entrada', from: invitation.remoteIdentity.uri.toString(), time: new Date().toLocaleString() }
            ]);
            // Se o atendimento automático estiver ativado, inicia um timer
            if (autoAnswerEnabled) {
              autoAnswerTimer.current = setTimeout(async () => {
                if (invitation && invitation.state !== SessionState.Established) {
                  console.log('Atendendo automaticamente após', autoAnswerTime, 'segundos');
                  await invitation.accept();
                  setCurrentSession(invitation);
                  setIncomingSession(null);
                }
              }, autoAnswerTime * 1000);
            }
          }
        };

        await ua.start();
        console.log('User Agent iniciado');
        setRegistrationStatus('User Agent iniciado');

        // Realiza o registro
        const reg = new Registerer(ua);
        await reg.register();
        console.log('Registrado com sucesso');
        setRegistrationStatus('Registrado com sucesso');
        setRegisterer(reg);
        setUserAgent(ua);
      } catch (err) {
        console.error('Erro ao iniciar o User Agent ou registrar:', err);
        setRegistrationStatus('Erro ao iniciar ou registrar');
      }
    };

    initUserAgent();
  }, [config, autoAnswerEnabled, autoAnswerTime]);

  // Função para atendimento manual de chamada recebida
  const handleManualAnswer = async () => {
    if (incomingSession) {
      if (autoAnswerTimer.current) {
        clearTimeout(autoAnswerTimer.current);
      }
      try {
        await incomingSession.accept();
        setCurrentSession(incomingSession);
        setIncomingSession(null);
      } catch (err) {
        console.error('Erro ao atender a chamada manualmente:', err);
      }
    }
  };

  // Função para realizar uma chamada utilizando Inviter com async/await
  const makeCall = async () => {
    if (userAgent && destination) {
      try {
        const target = UserAgent.makeURI(`sip:${destination}@${config.server}`);
        const inviter = new Inviter(userAgent, target, {
          sessionDescriptionHandlerOptions: { constraints: { audio: true, video: false } }
        });
        const session = await inviter.invite();
        setCurrentSession(session);
        setCallHistory(prev => [
          ...prev,
          { type: 'Saída', to: destination, time: new Date().toLocaleString() }
        ]);
        session.stateChange.addListener((newState) => {
          if (newState === SessionState.Terminated) {
            setCurrentSession(null);
          }
        });
      } catch (err) {
        console.error("Erro ao realizar a chamada:", err);
      }
    }
  };

  // Função para encerrar a chamada ativa
  const hangUp = async () => {
    if (currentSession) {
      try {
        await currentSession.bye();
        setCurrentSession(null);
      } catch (err) {
        console.error("Erro ao encerrar a chamada:", err);
      }
    }
  };

  return (
    <div className="section">
      <div className="container">
        <h1 className="title">Cliente WebRTC - Asterisk (PJSIP)</h1>
        <div className="notification is-info">
          <p>
            <strong>Servidor:</strong> {config.server} <br />
            <strong>Ramal:</strong> {config.name}
          </p>
          <p>
            <strong>Status do Registro:</strong> {registrationStatus}
          </p>
        </div>

        {/* Configurações de atendimento */}
        <div className="box">
          <div className="field">
            <label className="checkbox">
              <input 
                type="checkbox"
                checked={autoAnswerEnabled}
                onChange={() => setAutoAnswerEnabled(!autoAnswerEnabled)}
              />
              &nbsp;Atender automaticamente
            </label>
          </div>
          {autoAnswerEnabled && (
            <div className="field is-grouped">
              <label className="label">Tempo (segundos):</label>
              <div className="control">
                <input 
                  type="number" 
                  className="input"
                  value={autoAnswerTime}
                  onChange={e => setAutoAnswerTime(Number(e.target.value))}
                  style={{ width: '100px' }}
                />
              </div>
            </div>
          )}
        </div>

        {/* Área para realizar chamadas */}
        <div className="field has-addons">
          <div className="control is-expanded">
            <input 
              type="text" 
              className="input" 
              placeholder="Digite a extensão para chamar" 
              value={destination} 
              onChange={e => setDestination(e.target.value)} 
            />
          </div>
          <div className="control">
            <button onClick={makeCall} disabled={!!currentSession} className="button is-primary">
              Chamar
            </button>
          </div>
          <div className="control">
            <button onClick={hangUp} disabled={!currentSession} className="button is-danger">
              Desligar
            </button>
          </div>
        </div>

        {/* Área de atendimento de chamadas recebidas */}
        {incomingSession && (
          <div className="notification is-info">
            <p>Chamada recebida de: {incomingSession.remoteIdentity.uri.toString()}</p>
            <button onClick={handleManualAnswer} className="button is-success">
              Atender
            </button>
          </div>
        )}

        {/* Histórico de chamadas */}
        <h2 className="title is-4">Histórico de Chamadas</h2>
        {callHistory.length ? (
          <ul>
            {callHistory.map((call, index) => (
              <li key={index}>
                {call.type === 'Entrada'
                  ? `Chamada recebida de: ${call.from}`
                  : `Chamada realizada para: ${call.to}`
                } - {call.time}
              </li>
            ))}
          </ul>
        ) : (
          <p>Nenhuma chamada registrada.</p>
        )}
      </div>
    </div>
  );
}

export default WebRTC;
